import { Component, OnInit } from '@angular/core';

import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-logout-component',
    template: '',
    standalone: false
})

export class LogoutComponent implements OnInit {
  constructor(
    private authService: MsalService,
  ) {}

  ngOnInit(): void {
    this.authService.logout();
  }
}
